import React from "react";
import {
  Container,
  Box,
  Typography,
  useTheme,
  Grid,
  Stack,
  Chip,
  Pagination,
} from "@mui/material";
import {
  AccessTime,
  DateRange,
  ChevronLeft,
  ChevronRight,
} from "@mui/icons-material";
import BlogCard from "./BlogCard";

export default function Blogs() {
  const theme = useTheme();

  // نمونه دیتا برای همه مقالات (با همون ساختار BlogCard)
  const allBlogPosts = [
    {
      _id: 1,
      title: "۱۰ نکته طلایی برای افزایش عضله‌سازی",
      description:
        "با رعایت این نکات ساده می‌توانید روند عضله‌سازی خود را تا ۲ برابر افزایش دهید. از تغذیه مناسب تا تمرینات اصولی...",
      image: "/media/sample/sample.jpg",
      category: "بدنسازی",
      author: "مهدی کریمی",
      authorAvatar: "https://randomuser.me/api/portraits/men/1.jpg",
      readTime: 5,
      date: "۱۴۰۳/۰۲/۱۵",
    },
    {
      _id: 2,
      title: "رازهای تغذیه سالم برای ورزشکاران",
      description:
        "چه بخوریم قبل و بعد از تمرین؟ بهترین زمان مصرف پروتئین و کربوهیدرات برای افزایش عملکرد و ریکاوری سریع‌تر...",
      image: "/media/sample/sample.jpg",
      category: "تغذیه ورزشی",
      author: "سارا احمدی",
      authorAvatar: "https://randomuser.me/api/portraits/women/2.jpg",
      readTime: 7,
      date: "۱۴۰۳/۰۲/۱۰",
    },
    {
      _id: 3,
      title: "راهنمای کامل یوگا برای مبتدیان",
      description:
        "حرکات پایه یوگا که هر مبتدی باید بداند + فواید شگفت‌انگیز آن برای سلامت جسم و روان...",
      image: "/media/sample/sample.jpg",
      category: "یوگا",
      author: "ندا حسینی",
      authorAvatar: "https://randomuser.me/api/portraits/women/4.jpg",
      readTime: 6,
      date: "۱۴۰۳/۰۲/۰۵",
    },
    {
      _id: 4,
      title: "۵ اشتباه رایج در تمرینات کراس فیت",
      description:
        "از این اشتباهات خطرناک در کراس فیت دوری کنید تا آسیب نبینید و بهترین نتیجه را از تمرینات خود بگیرید...",
      image: "/media/sample/sample.jpg",
      category: "کراس فیت",
      author: "رضا نوری",
      authorAvatar: "https://randomuser.me/api/portraits/men/3.jpg",
      readTime: 4,
      date: "۱۴۰۳/۰۱/۲۸",
    },
    {
      _id: 5,
      title: "بهترین زمان ورزش کردن در روز",
      description:
        "صبح ورزش کنیم یا عصر؟ تحقیقات جدید چه می‌گویند؟ بررسی مزایا و معایب هر دو زمان...",
      image: "/media/sample/sample.jpg",
      category: "مقالات علمی",
      author: "امیر موسوی",
      authorAvatar: "https://randomuser.me/api/portraits/men/5.jpg",
      readTime: 3,
      date: "۱۴۰۳/۰۱/۲۰",
    },
    {
      _id: 6,
      title: "راهنمای خرید مکمل‌های ورزشی",
      description:
        "کدام مکمل‌ها واقعاً مؤثرند و کدامها فقط هدر دادن پول است؟ راهنمای کامل برای مبتدیان...",
      image: "/media/sample/sample.jpg",
      category: "مکمل‌ها",
      author: "علی رضایی",
      authorAvatar: "https://randomuser.me/api/portraits/men/6.jpg",
      readTime: 8,
      date: "۱۴۰۳/۰۱/۱۵",
    },
    {
      _id: 7,
      title: "تمرینات قدرتی برای بانوان",
      description:
        "آیا وزنه زدن برای خانم‌ها باعث حجیم شدن می‌شود؟ حقیقت علمی درباره تمرینات قدرتی و تأثیر آن بر بدن بانوان...",
      image: "/media/sample/sample.jpg",
      category: "فیتنس",
      author: "مریم حسینی",
      authorAvatar: "https://randomuser.me/api/portraits/women/7.jpg",
      readTime: 5,
      date: "۱۴۰۳/۰۱/۱۰",
    },
    {
      _id: 8,
      title: "ریکاوری فعال چیست و چرا مهم است؟",
      description:
        "آیا می‌دانستید روزهای استراحت به اندازه روزهای تمرین مهم هستند؟ روش‌های صحیح ریکاوری برای پیشرفت سریع‌تر...",
      image: "/media/sample/sample.jpg",
      category: "علم ورزش",
      author: "پدرام صادقی",
      authorAvatar: "https://randomuser.me/api/portraits/men/8.jpg",
      readTime: 4,
      date: "۱۴۰۳/۰۱/۰۵",
    },
  ];

  // دسته‌بندی‌ها برای فیلتر
  const categories = [
    "همه",
    "بدنسازی",
    "تغذیه ورزشی",
    "یوگا",
    "کراس فیت",
    "مقالات علمی",
    "مکمل‌ها",
    "فیتنس",
  ];

  const catItems = categories.map((cat, index) => (
    <Chip
      key={index}
      label={cat}
      clickable
      sx={{
        fontWeight: 500,
        fontSize: "0.85rem",
        px: 1,
        bgcolor:
          index === 0 ? `${theme.palette.primary.main}15` : "transparent",
        color: index === 0 ? theme.palette.primary.main : "text.secondary",
        border: `1px solid ${index === 0 ? theme.palette.primary.main : theme.palette.divider}`,
        "&:hover": {
          bgcolor: `${theme.palette.primary.main}10`,
          color: theme.palette.primary.main,
        },
      }}
    />
  ));

  const blogItems = allBlogPosts.map((post) => (
    <Grid size={{ xs: 12, md: 6, lg: 4 }} key={post._id}>
      <BlogCard post={post} />
    </Grid>
  ));
  return (
    <Box sx={{ bgcolor: "background.default", minHeight: "100vh", py: 6 }}>
      <Container maxWidth="xl" sx={{ px: { xs: 2, md: 3 } }}>
        {/* Header Section - به سبک BlogsSct */}
        <Box sx={{ mb: 5, textAlign: "center" }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 800,
              background: `linear-gradient(45deg, ${theme.palette.primary.main} 30%, ${theme.palette.primary.light} 90%)`,
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              mb: 1,
            }}
          >
            مجله ورزشی
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ maxWidth: 600, mx: "auto" }}
          >
            جدیدترین مقالات و نکات آموزشی دنیای ورزش، تغذیه و تناسب اندام
          </Typography>
        </Box>

        {/* Category Chips - فیلتر دسته‌بندی */}
        <Stack
          direction="row"
          sx={{
            flexWrap: "wrap",
            justifyContent: "center",
            gap: 1.5,
            mb: 5,
            pb: 2,
            overflowX: "auto",
          }}
        >
          {catItems}
        </Stack>

        {/* Blog Grid - با استفاده از همون BlogCard */}
        <Grid container spacing={3}>
          {blogItems}
        </Grid>

        {/* Pagination */}
        <Stack direction="row" justifyContent="center" sx={{ mt: 6 }}>
          <Stack direction="row" spacing={1} alignItems="center">
            <ChevronRight sx={{ color: "text.secondary", cursor: "pointer" }} />
            <Typography
              sx={{
                px: 1.5,
                py: 0.5,
                bgcolor: theme.palette.primary.main,
                color: "white",
                borderRadius: 1,
              }}
            >
              ۱
            </Typography>
            <Typography
              sx={{
                px: 1.5,
                py: 0.5,
                cursor: "pointer",
                color: "text.secondary",
              }}
            >
              ۲
            </Typography>
            <Typography
              sx={{
                px: 1.5,
                py: 0.5,
                cursor: "pointer",
                color: "text.secondary",
              }}
            >
              ۳
            </Typography>
            <ChevronLeft sx={{ color: "text.secondary", cursor: "pointer" }} />
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
